import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import LoanFileDownloadUI from './LoanFileDownloadUI.js'

class LoanFileDownloadSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      disbLetterSubmitted: false,
      downloadCCDocRequested: false,
      downloadSNDocRequested: false,
      ccErrorList: null,
      snErrorList: null,
      downloadSMItrRequested: false,
      onDownloadLoanStatementRequested: false,
      onDownloadComfortLetterRequested: false,
      downloadRetailAgreementRequested: false,
      smItrErrorList: false,
      downloadCreditMemoRequested: false,
      showCreditMemoConfirmModal: false,
      refreshCreditMemosRequested: false,
    }
  }

  render() {
    return (
      <LoanFileDownloadUI
        context={this.props.context}
        loan={this.props.loan}
        account={this.props.account}
        //
        onDownloadDisbursementLetter={this.onDownloadDisbursementLetter}
        disbLetterSubmitted={this.state.disbLetterSubmitted}
        //
        onDownloadLoanStatement={this.onDownloadLoanStatement}
        onDownloadLoanStatementRequested={this.state.onDownloadLoanStatementRequested}
        //
        onDownloadComfortLetter={this.onDownloadComfortLetter}
        onDownloadComfortLetterRequested={this.state.onDownloadComfortLetterRequested}
        //
        onDownloadCCDoc={this.onDownloadCCDoc}
        downloadCCDocRequested={this.state.downloadCCDocRequested}
        ccErrorList={this.state.ccErrorList}
        //
        onDownloadSNDoc={this.onDownloadSNDoc}
        downloadSNDocRequested={this.state.downloadSNDocRequested}
        snErrorList={this.state.snErrorList}
        //
        onDownloadSMItr={this.onDownloadSMItr}
        downloadSMItrRequested={this.state.downloadSMItrRequested}
        smItrErrorList={this.state.smItrErrorList}
        //
        onDownloadRetailAgreement={this.onDownloadRetailAgreement}
        downloadRetailAgreementRequested={this.state.downloadRetailAgreementRequested}
        //
        creditMemoList={this.props.creditMemoList}
        selectedCreditMemo={this.props.selectedCreditMemo}
        generateCreditMemoRequested={this.props.generateCreditMemoRequested}
        onGenerateCreditMemo={this.onShowCreditMemoConfirm}
        onRefreshCreditMemos={this.onRefreshCreditMemos}
        refreshCreditMemosRequested={this.state.refreshCreditMemosRequested}
        onCreditMemoSelect={this.props.onCreditMemoSelect}
        showCreditMemoConfirmModal={this.state.showCreditMemoConfirmModal}
        onConfirmGenerateCreditMemo={this.onConfirmGenerateCreditMemo}
        onCancelGenerateCreditMemo={this.onCancelGenerateCreditMemo}
        onStartChat={this.props.onStartChat}
        showChatIframe={this.props.showChatIframe}
        onCloseChatIframe={this.props.onCloseChatIframe}
        onDownloadCreditMemoPdf={this.onDownloadCreditMemoPdf}
        downloadCreditMemoPdfRequested={this.state.downloadCreditMemoPdfRequested}
        showCreditMemoResultModal={this.props.showCreditMemoResultModal}
        creditMemoResultMessage={this.props.creditMemoResultMessage}
        creditMemoResultType={this.props.creditMemoResultType}
        onCloseCreditMemoResultModal={this.props.onCloseCreditMemoResultModal}
      />
    )
  }

  onDownloadDisbursementLetter = () => {
    let context = this.props.context
    this.setState({ disbLetterSubmitted: true })
    RestApiUtils.post(context, `/api/su/loans/${this.props.loan.loanId}/disbursements/letter`,
      this.onDownloadDisbursementLetterCallback, {})
  }

  onDownloadDisbursementLetterCallback = (response) => {
    this.setState({ disbLetterSubmitted: false })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onDownloadLoanStatement = () => {
    console.log("Put");
    let context = this.props.context
    this.setState({ onDownloadLoanStatementRequested: true })
    RestApiUtils.post(context, `/api/su/loans/${this.props.loan.loanId}/disbursements/statement/fileDownloadSignedUrl`,
      this.onDownloadLoanStatementCallback, {})
  }

  onDownloadLoanStatementCallback = (response) => {
    this.setState({ onDownloadLoanStatementRequested: false })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onDownloadComfortLetter = () => {
    let context = this.props.context
    this.setState({ onDownloadComfortLetterRequested: true })
    RestApiUtils.get(context, `/api/su/loans/${this.props.loan.loanId}/filledDocument/loan_comfort_letter/fileDownloadSignedUrl`,
      this.onDownloadComfortLetterCallback, null, null)
  }

  onDownloadComfortLetterCallback = (response) => {
    this.setState({ onDownloadComfortLetterRequested: false })
    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onDownloadRetailAgreement = () => {
    let context = this.props.context
    this.setState({ onDownlaodRetailAgreement: true })
    RestApiUtils.get(context, `/api/su/loans/${this.props.loan.loanId}/filledDocument/loan_retail_agreement/fileDownloadSignedUrl`,
      this.onDownloadRetailAgreementCallback, null, null
    )
  }

  onDownloadRetailAgreementCallback = (response) => {
    this.setState({
      raErrorList: response.errorList,
      onDownlaodRetailAgreement: false
    })
    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onDownloadCCDoc = () => {
    this.setState({ downloadCCDocRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/filledDocument/credit_committee/fileDownloadSignedUrl`,
      this.onDownloadCCDocCallback, null, null
    )
  }

  onDownloadCCDocCallback = (response) => {
    this.setState({
      ccErrorList: response.errorList,
      downloadCCDocRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      // setTimeout(() => {
      //   this.setState({
      //     successMsg: null
      //   })
      //   this.props.onCancelClick()
      // }, 2000)
    }
  }

  onDownloadSNDoc = () => {
    this.setState({ downloadSNDocRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/filledDocument/structure_memo/fileDownloadSignedUrl`,
      this.onDownloadSNDocCallback, null, null
    )
  }

  onDownloadSNDocCallback = (response) => {
    this.setState({
      snErrorList: response.errorList,
      downloadSNDocRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      // setTimeout(() => {
      //   this.setState({
      //     successMsg: null
      //   })
      //   this.props.onCancelClick()
      // }, 2000)
    }
  }

  onDownloadSMItr = () => {
    this.setState({ downloadSMItrRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/filledDocument/structure_memo_itr/fileDownloadSignedUrl`,
      this.onDownloadSMItrCallback, null, null
    )
  }

  onDownloadSMItrCallback = (response) => {
    this.setState({
      smItrErrorList: response.errorList,
      downloadSMItrRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onDownloadCreditMemoPdf = (cin, createdAt) => {
      let context = this.props.context
      this.setState({ downloadCreditMemoPdfRequested: true })
      RestApiUtils.get(
          context,
          `/api/credit_memo/download/${cin}/${createdAt}`,
          this.onDownloadCreditMemoCallback,
          null,
          null
      )
  }

  onDownloadCreditMemoCallback = (response) => {
      console.log('Credit memo download callback:', response);
      this.setState({ downloadCreditMemoPdfRequested: false })
      if (response) {
          const link = document.createElement('a')
          link.href = response.signedUrl
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
      }

  }

  onShowCreditMemoConfirm = () => {
    this.setState({ showCreditMemoConfirmModal: true })
  }

  onConfirmGenerateCreditMemo = () => {
    this.setState({ showCreditMemoConfirmModal: false })
    this.props.onGenerateCreditMemo()
  }

  onCancelGenerateCreditMemo = () => {
    this.setState({ showCreditMemoConfirmModal: false })
  }

  onRefreshCreditMemos = () => {
    this.setState({ refreshCreditMemosRequested: true })
    if (this.props.onRefreshCreditMemos) {
      this.props.onRefreshCreditMemos(() => {
        this.setState({ refreshCreditMemosRequested: false })
      })
    } else {
      this.setState({ refreshCreditMemosRequested: false })
    }
  }
}

export default LoanFileDownloadSF
